import "./Icons.css";
import { useStyles } from "../Layout/useStyles";

const width = "50px";
const height = "50px";
const widthBig = "60px";
const heightBig = "60px";

function PinIcon({ size }) {
  const classes = useStyles();

  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <path
        className="pin-st0"
        d="M50,16c-14.1,0-25.6,11.5-25.6,25.6c0,8.6,7.7,21.2,11,26.3c3.6,5.5,11.4,16,14.6,16s10.9-10.5,14.6-16
	c3.3-5,11-17.7,11-26.3C75.6,27.5,64.1,16,50,16z M49.8,52.4c-5.5,0-10-4.5-10-10s4.5-10,10-10s10,4.5,10,10S55.3,52.4,49.8,52.4z"
      />
    </svg>
  );
}

function BalloonIcon() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <g id="Layer_2_1_">
        <g>
          <ellipse
            className="balloon-st0"
            cx="50"
            cy="97.7"
            rx="7.4"
            ry="2.3"
          />
          <path
            className="balloon-st1"
            d="M51,64.9c6.2-4.9,22.3-27.9,22.3-39.3C73.3,12.8,62.9,2.3,50,2.3S26.7,12.8,26.7,25.6
      C26.7,37.1,42.7,60,49,64.9c0.5,0.4,0.6,1,0.2,1.5c-0.7,1.1-1.3,2.6-1.8,3.7h5.1c-0.4-1.1-1.1-2.7-1.8-3.7
      C50.4,66,50.5,65.3,51,64.9z"
          />
          <path
            className="balloon-st2"
            d="M51,64.9c6.2-4.9,22.3-27.9,22.3-39.3C73.3,12.8,62.9,2.3,50,2.3S26.7,12.8,26.7,25.6
      C26.7,37.1,42.7,60,49,64.9c0.5,0.4,0.6,1,0.2,1.5c-0.7,1.1-1.3,2.6-1.8,3.7h5.1c-0.4-1.1-1.1-2.7-1.8-3.7
      C50.4,66,50.5,65.3,51,64.9z"
          />
          <path
            d="M48.9,80.3c1.5,2.1,2.9,4,0.3,10.2L49,91l2.1,0.9l0.2-0.4c3.1-7.4,1.1-10.2-0.6-12.5c-1.2-1.7-2.1-2.9,0-6.4h-2.6
      C46.1,76.6,47.5,78.5,48.9,80.3z"
          />
          <path
            className="balloon-st3"
            d="M53.2,66.1c6.8-6.1,22.4-28.4,22.4-40.5C75.6,11.5,64.1,0,50,0S24.4,11.5,24.4,25.6c0,12,15.6,34.3,22.4,40.5
      c-1.2,2.1-2,4.8-2,4.9c-0.1,0.4,0,0.7,0.2,1s0.6,0.5,0.9,0.5h2.2h2.6h3.5c0.4,0,0.7-0.2,0.9-0.5s0.3-0.7,0.2-1
      C55.2,70.9,54.4,68.2,53.2,66.1z M50.8,66.5c0.7,1.1,1.3,2.6,1.8,3.7h-5.1c0.4-1.1,1.1-2.7,1.8-3.7c0.3-0.5,0.2-1.2-0.2-1.5
      C42.7,60,26.7,37.1,26.7,25.6C26.7,12.8,37.1,2.3,50,2.3s23.3,10.5,23.3,23.3C73.3,37.1,57.3,60,51,64.9
      C50.5,65.3,50.4,66,50.8,66.5z"
          />
          <path
            className="balloon-st4"
            d="M55.5,7.6c0.9-0.3,1.9-0.3,2.8-0.1c0.9,0.2,1.8,0.6,2.6,1c1.6,0.9,3,2,4.2,3.4c1.2,1.4,2.2,2.9,2.9,4.6
      c0.3,0.9,0.6,1.8,0.7,2.7c0.1,0.9,0.1,1.9-0.2,2.7c-0.7-1.7-1.5-3-2.4-4.4c-0.9-1.3-1.9-2.6-3-3.8c-1.1-1.2-2.2-2.4-3.4-3.4
      c-0.6-0.5-1.2-1.1-1.9-1.5C57.1,8.3,56.4,7.9,55.5,7.6z"
          />
        </g>
      </g>
    </svg>
  );
}

function HomeIcon() {
  return (
    <svg
      version="1.1"
      id="homeIcon"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={widthBig}
      height={heightBig}
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <style type="text/css"></style>
      <g id="Layer_2_1_">
        <g>
          <ellipse className="home-st0" cx="50" cy="97.7" rx="7.4" ry="2.3" />
          <path
            className="home-st1"
            d="M50,25.4c-12.9,0-23.3,10.5-23.3,23.3c0,5.5,3.8,14.5,10.4,24.6c6.3,9.7,11.6,15,12.9,15.3
          c1.3-0.3,6.6-5.6,12.9-15.3c6.6-10.1,10.4-19.1,10.4-24.6C73.3,35.9,62.9,25.4,50,25.4z"
          />
          <path
            className="home-st2"
            d="M50,23.1c-14.1,0-25.6,11.5-25.6,25.6c0,8.6,7.7,21.2,11,26.3c3.6,5.5,11.4,16,14.6,16s10.9-10.5,14.6-16
          c3.3-5,11-17.7,11-26.3C75.6,34.6,64.1,23.1,50,23.1z M50,88.7c-1.3-0.3-6.6-5.6-12.9-15.3c-6.6-10.1-10.4-19.1-10.4-24.6
          c0-12.9,10.5-23.3,23.3-23.3s23.3,10.5,23.3,23.3c0,5.5-3.8,14.5-10.4,24.6C56.6,83,51.3,88.3,50,88.7z"
          />
          <path
            className="home-st3"
            d="M49.4,40.8L39,49.3v9.2c0,0.5,0.4,0.9,0.9,0.9l6.3,0c0.5,0,0.9-0.4,0.9-0.9v-5.4c0-0.5,0.4-0.9,0.9-0.9h3.6
          c0.5,0,0.9,0.4,0.9,0.9v5.4c0,0.5,0.4,0.9,0.9,0.9c0,0,0,0,0,0l6.3,0c0.5,0,0.9-0.4,0.9-0.9v-9.2l-10.3-8.5
          C50,40.6,49.6,40.6,49.4,40.8L49.4,40.8z M65.7,46.6L61,42.7V35c0-0.4-0.3-0.7-0.7-0.7h-3.1c-0.4,0-0.7,0.3-0.7,0.7V39l-5-4.1
          c-1-0.8-2.4-0.8-3.4,0L33.9,46.6c-0.3,0.2-0.3,0.7-0.1,0.9c0,0,0,0,0,0l1.4,1.7c0.2,0.3,0.7,0.3,0.9,0.1c0,0,0,0,0,0l13.2-10.9
          c0.3-0.2,0.6-0.2,0.9,0l13.2,10.9c0.3,0.2,0.7,0.2,0.9-0.1c0,0,0,0,0,0l1.4-1.7C66.1,47.3,66,46.8,65.7,46.6
          C65.7,46.6,65.7,46.6,65.7,46.6L65.7,46.6z"
          />
        </g>
      </g>
    </svg>
  );
}

function HotelIcon() {
  return (
    <svg
      version="1.1"
      id="hotelIcon"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <g id="Layer_2_1_">
        <g>
          <ellipse className="hotel-st0" cx="50" cy="97.7" rx="7.4" ry="2.3" />
          <path
            className="hotel-st1"
            d="M50,25.4c-12.9,0-23.3,10.5-23.3,23.3c0,5.5,3.8,14.5,10.4,24.6c6.3,9.7,11.6,15,12.9,15.3
			c1.3-0.3,6.6-5.6,12.9-15.3c6.6-10.1,10.4-19.1,10.4-24.6C73.3,35.9,62.9,25.4,50,25.4z"
          />
          <path
            className="hotel-st2"
            d="M50,23.1c-14.1,0-25.6,11.5-25.6,25.6c0,8.6,7.7,21.2,11,26.3c3.6,5.5,11.4,16,14.6,16s10.9-10.5,14.6-16
			c3.3-5,11-17.7,11-26.3C75.6,34.6,64.1,23.1,50,23.1z M50,88.7c-1.3-0.3-6.6-5.6-12.9-15.3c-6.6-10.1-10.4-19.1-10.4-24.6
			c0-12.9,10.5-23.3,23.3-23.3s23.3,10.5,23.3,23.3c0,5.5-3.8,14.5-10.4,24.6C56.6,83,51.3,88.3,50,88.7z"
          />
          <path
            className="hotel-st3"
            d="M42.7,49.7c2.2,0,4-1.8,4-4c0-2.2-1.8-4-4-4s-4,1.8-4,4C38.7,47.9,40.5,49.7,42.7,49.7z M60.5,43.3H49.2
			c-0.4,0-0.8,0.4-0.8,0.8v7.3H37.1V40.8c0-0.4-0.4-0.8-0.8-0.8h-1.6c-0.4,0-0.8,0.4-0.8,0.8v17.8c0,0.4,0.4,0.8,0.8,0.8h1.6
			c0.4,0,0.8-0.4,0.8-0.8v-2.4h25.9v2.4c0,0.4,0.4,0.8,0.8,0.8h1.6c0.4,0,0.8-0.4,0.8-0.8v-9.7C66.2,45.8,63.6,43.3,60.5,43.3z"
          />
        </g>
      </g>
    </svg>
  );
}

function CityIcon() {
  return (
    <svg
      version="1.1"
      id="cityIcon"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={widthBig}
      height={heightBig}
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <g id="Layer_2_1_">
        <g>
          <ellipse className="city-st0" cx="50" cy="97.7" rx="7.4" ry="2.3" />
          <path
            className="city-st1"
            d="M50,25.4c-12.9,0-23.3,10.5-23.3,23.3c0,5.5,3.8,14.5,10.4,24.6c6.3,9.7,11.6,15,12.9,15.3
			c1.3-0.3,6.6-5.6,12.9-15.3c6.6-10.1,10.4-19.1,10.4-24.6C73.3,35.9,62.9,25.4,50,25.4z"
          />
          <path
            className="city-st2"
            d="M50,23.1c-14.1,0-25.6,11.5-25.6,25.6c0,8.6,7.7,21.2,11,26.3c3.6,5.5,11.4,16,14.6,16s10.9-10.5,14.6-16
			c3.3-5,11-17.7,11-26.3C75.6,34.6,64.1,23.1,50,23.1z M50,88.7c-1.3-0.3-6.6-5.6-12.9-15.3c-6.6-10.1-10.4-19.1-10.4-24.6
			c0-12.9,10.5-23.3,23.3-23.3s23.3,10.5,23.3,23.3c0,5.5-3.8,14.5-10.4,24.6C56.6,83,51.3,88.3,50,88.7z"
          />
          <path
            className="city-st3"
            d="M65,43.3h-6.9v-8.5c0-0.7-0.5-1.2-1.2-1.2h-7.3c-0.7,0-1.2,0.5-1.2,1.2v3.6h-3.2h-2.4h-3.2h-2.4h-2
			c-0.7,0-1.2,0.5-1.2,1.2v18.2c0,0.9,0.7,1.6,1.6,1.6h29.1c0.9,0,1.6-0.7,1.6-1.6V44.5C66.2,43.8,65.6,43.3,65,43.3z M40.3,54
			c0,0.3-0.3,0.6-0.6,0.6h-2c-0.3,0-0.6-0.3-0.6-0.6v-2c0-0.3,0.3-0.6,0.6-0.6h2c0.3,0,0.6,0.3,0.6,0.6V54z M40.3,49.1
			c0,0.3-0.3,0.6-0.6,0.6h-2c-0.3,0-0.6-0.3-0.6-0.6v-2c0-0.3,0.3-0.6,0.6-0.6h2c0.3,0,0.6,0.3,0.6,0.6V49.1z M40.3,44.3
			c0,0.3-0.3,0.6-0.6,0.6h-2c-0.3,0-0.6-0.3-0.6-0.6v-2c0-0.3,0.3-0.6,0.6-0.6h2c0.3,0,0.6,0.3,0.6,0.6V44.3z M46.8,54
			c0,0.3-0.3,0.6-0.6,0.6h-2c-0.3,0-0.6-0.3-0.6-0.6v-2c0-0.3,0.3-0.6,0.6-0.6h2c0.3,0,0.6,0.3,0.6,0.6V54z M46.8,49.1
			c0,0.3-0.3,0.6-0.6,0.6h-2c-0.3,0-0.6-0.3-0.6-0.6v-2c0-0.3,0.3-0.6,0.6-0.6h2c0.3,0,0.6,0.3,0.6,0.6V49.1z M46.8,44.3
			c0,0.3-0.3,0.6-0.6,0.6h-2c-0.3,0-0.6-0.3-0.6-0.6v-2c0-0.3,0.3-0.6,0.6-0.6h2c0.3,0,0.6,0.3,0.6,0.6V44.3z M54.8,49.1
			c0,0.3-0.3,0.6-0.6,0.6h-2c-0.3,0-0.6-0.3-0.6-0.6v-2c0-0.3,0.3-0.6,0.6-0.6h2c0.3,0,0.6,0.3,0.6,0.6V49.1z M54.8,44.3
			c0,0.3-0.3,0.6-0.6,0.6h-2c-0.3,0-0.6-0.3-0.6-0.6v-2c0-0.3,0.3-0.6,0.6-0.6h2c0.3,0,0.6,0.3,0.6,0.6V44.3z M54.8,39.4
			c0,0.3-0.3,0.6-0.6,0.6h-2c-0.3,0-0.6-0.3-0.6-0.6v-2c0-0.3,0.3-0.6,0.6-0.6h2c0.3,0,0.6,0.3,0.6,0.6V39.4z M62.9,54
			c0,0.3-0.3,0.6-0.6,0.6h-2c-0.3,0-0.6-0.3-0.6-0.6v-2c0-0.3,0.3-0.6,0.6-0.6h2c0.3,0,0.6,0.3,0.6,0.6C62.9,51.9,62.9,54,62.9,54z
			 M62.9,49.1c0,0.3-0.3,0.6-0.6,0.6h-2c-0.3,0-0.6-0.3-0.6-0.6v-2c0-0.3,0.3-0.6,0.6-0.6h2c0.3,0,0.6,0.3,0.6,0.6
			C62.9,47.1,62.9,49.1,62.9,49.1z"
          />
        </g>
      </g>
    </svg>
  );
}

function FoodIcon() {
  return (
    <svg
      version="1.1"
      id="foodIcon"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <g id="Layer_2_1_">
        <g>
          <ellipse className="food-st0" cx="50" cy="97.7" rx="7.4" ry="2.3" />
          <path
            className="food-st1"
            d="M50,25.4c-12.9,0-23.3,10.5-23.3,23.3c0,5.5,3.8,14.5,10.4,24.6c6.3,9.7,11.6,15,12.9,15.3
			c1.3-0.3,6.6-5.6,12.9-15.3c6.6-10.1,10.4-19.1,10.4-24.6C73.3,35.9,62.9,25.4,50,25.4z"
          />
          <path
            className="food-st2"
            d="M50,23.1c-14.1,0-25.6,11.5-25.6,25.6c0,8.6,7.7,21.2,11,26.3c3.6,5.5,11.4,16,14.6,16s10.9-10.5,14.6-16
			c3.3-5,11-17.7,11-26.3C75.6,34.6,64.1,23.1,50,23.1z M50,88.7c-1.3-0.3-6.6-5.6-12.9-15.3c-6.6-10.1-10.4-19.1-10.4-24.6
			c0-12.9,10.5-23.3,23.3-23.3s23.3,10.5,23.3,23.3c0,5.5-3.8,14.5-10.4,24.6C56.6,83,51.3,88.3,50,88.7z"
          />
          <path
            className="food-st3"
            d="M49.9,35c0,0.3,0.9,5.2,0.9,7.2c0,2.9-1.5,5-3.8,5.8l0.7,13.2c0,0.8-0.6,1.4-1.3,1.4h-3.6
			c-0.8,0-1.4-0.6-1.3-1.4l0.7-13.2c-2.3-0.8-3.8-2.9-3.8-5.8c0-1.9,0.8-6.9,0.9-7.2c0.2-1.1,2.5-1.1,2.7,0.1v7.8
			c0.1,0.2,0.8,0.2,0.9,0c0.1-1.4,0.4-7.7,0.4-7.9c0.2-1.2,2.5-1.2,2.7,0c0,0.1,0.4,6.5,0.4,7.9c0,0.2,0.8,0.2,0.9,0V35
			C47.4,33.8,49.8,33.8,49.9,35z M56.5,50.8l-0.8,10.3c-0.1,0.8,0.5,1.4,1.3,1.4h3.1c0.7,0,1.3-0.6,1.3-1.3V35.5
			c0-0.7-0.6-1.3-1.3-1.3C55.6,34.1,47.9,44,56.5,50.8L56.5,50.8z"
          />
        </g>
      </g>
    </svg>
  );
}

export { HomeIcon, HotelIcon, BalloonIcon, CityIcon, FoodIcon, PinIcon };
